import styled from "styled-components";

import { ColumnList } from "features/media/components/molecules/ColumnList";
import { Topic, TopicCategory } from "shared/types";
import { Pager } from "shared/components/molecules/Pager";
import { MultiColumnList } from "../molecules/MultiColumnList";
import { useRouter } from "next/router";
import { CategoryAndTagList } from "components/organisms/CategoryAndTagList";
import { Loading } from "shared/components/templates/Loading";

interface Props {
  title: string;
  topics: Topic[];
  categories: TopicCategory[];
  currentPage: string | string[] | number;
  totalPage?: number;
  isLoading?: boolean;
}

export const ColumnListLayout = ({
  title,
  topics,
  categories,
  currentPage,
  totalPage = 1,
  isLoading,
}: Props) => {
  const { push } = useRouter();

  const onClickCategory = async (data: TopicCategory) => {
    await push(`/${data.mediaType}/column-category/${data.alias}`);
  };

  return (
    <>
      <div tw="mt-6 px-4">
        <PageTitle>{`${title}コラム`}</PageTitle>
        <Description>
          {`このページではMIRORに掲載されている「${title}」に関するまとめ記事をたくさんご紹介しています。MIRORで「${title}」に関するまとめ記事をお楽しみください。`}
        </Description>
      </div>
      {isLoading ? <Loading loading /> : <ColumnList topics={topics} />}
      <div tw="my-6">
        <Pager currentPage={Number(currentPage)} totalPages={totalPage} />
      </div>
      {categories && (
        <MultiColumnList
          title="コラムカテゴリ"
          data={categories}
          keyName="name"
          onClick={onClickCategory}
        />
      )}
      <CategoryAndTagList tw="mt-4" />
    </>
  );
};

const PageTitle = styled.h1`
  font-weight: 600;
  font-size: 18px;
  letter-spacing: -0.17px;
  line-height: 18px;
  color: #3c424a;
  margin-bottom: 16px;
`;

const Description = styled.p`
  font-weight: 300;
  font-size: 12px;
  letter-spacing: 0.35px;
  line-height: 24px;
  color: #454b54;
`;
